// // // import React, { useState, useEffect } from 'react';
// // // import { useNavigate, useLocation } from 'react-router-dom';
// // // import { getDecodedToken, apiFetch } from '../../utils/auth';
// // // import './Header.css';

// // // const Header = () => {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();

// // //   // --- State for User Profile ---
// // //   const [userProfile, setUserProfile] = useState({
// // //     name: 'Loading...', 
// // //     role: '',
// // //     avatar: '' 
// // //   });

// // //   const [currentDate, setCurrentDate] = useState('');

// // //   // --- Helper: Get Page Title ---
// // //   const getPageTitle = (pathname) => {
// // //     if (pathname.includes('/dashboard')) return 'Dashboard';
// // //     if (pathname.includes('/user-management')) return 'User Management';
// // //     if (pathname.includes('/students')) return 'Student List';
// // //     if (pathname.includes('/analytics')) return 'Apps Analytics';
// // //     if (pathname.includes('/manage-app')) return 'Manage App';
// // //     if (pathname.includes('/settings')) return 'Settings';
// // //     return 'Overview';
// // //   };

// // //   useEffect(() => {
// // //     // 1. Set Date
// // //     const date = new Date();
// // //     const options = { weekday: 'long', day: 'numeric', month: 'short' };
// // //     setCurrentDate(date.toLocaleDateString('en-GB', options));

// // //     // 2. Fetch User Data
// // //     const loadData = async () => {
// // //       const decoded = getDecodedToken();

// // //       if (!decoded || !decoded.userId) {
// // //         // No token or invalid token? Redirect to login.
// // //         navigate('/login');
// // //         return;
// // //       }

// // //       // Default values from token (Role is usually in token, Name might not be)
// // //       let profileData = {
// // //         name: 'Administrator', // Temporary fallback
// // //         role: decoded.role || 'Admin',
// // //         avatar: ''
// // //       };

// // //       try {
// // //         // --- CRITICAL: Fetch user details from API using ID from Token ---
// // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // //         if (response.ok) {
// // //           const data = await response.json();

// // //           // Construct Full Name
// // //           const firstName = data.first_name || '';
// // //           const lastName = data.last_name || '';
// // //           const fullName = `${firstName} ${lastName}`.trim();

// // //           profileData.name = fullName || data.email || 'Administrator';
// // //           profileData.role = data.role || decoded.role;
// // //           profileData.avatar = data.photo_url || '';
// // //         } else {
// // //           console.warn("Failed to fetch user details from API");
// // //         }
// // //       } catch (error) {
// // //         console.error("Error connecting to user API:", error);
// // //       }

// // //       // --- Generate Avatar if none exists ---
// // //       if (!profileData.avatar) {
// // //         // Creates a colored box with initials (e.g., "SM")
// // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // //       }

// // //       setUserProfile(profileData);
// // //     };

// // //     loadData();
// // //   }, [navigate]);

// // //   return (
// // //     <header className="topbar">
// // //       {/* Left: Dynamic Title based on Route */}
// // //       <div className="header-left">
// // //         <span className="breadcrumb-main">Dashboard</span> 
// // //         <span className="breadcrumb-separator">/</span> 
// // //         <span className="breadcrumb-current">{getPageTitle(location.pathname)}</span>
// // //       </div>

// // //       {/* Right: User Info & Actions */}
// // //       <div className="header-right">
// // //         <span className="date-display">{currentDate}</span>

// // //         <div className="icon-group">
// // //             <button className="icon-btn" title="Notifications">
// // //                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
// // //                 <span className="notification-dot"></span>
// // //             </button>
// // //             <button className="icon-btn" title="Settings" onClick={() => navigate('/settings')}>
// // //                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
// // //             </button>
// // //         </div>

// // //         {/* Profile Section */}
// // //         <div className="profile-section" onClick={() => navigate('/settings')}>
// // //           <img 
// // //             src={userProfile.avatar} 
// // //             alt="Profile" 
// // //             className="profile-img" 
// // //           />
// // //           <div className="profile-info">
// // //             {/* This displays the Name fetched from API */}
// // //             <span className="profile-name">{userProfile.name}</span>
// // //             {/* This displays the Role fetched from API/Token */}
// // //             <span className="profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </header>
// // //   );
// // // };

// // // export default Header;


// // import React, { useState, useEffect } from 'react';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import { getDecodedToken, apiFetch } from '../../utils/auth';
// // import './Header.css';

// // const Header = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [userProfile, setUserProfile] = useState({
// //     name: 'Loading...',
// //     role: '',
// //     avatar: null // Use null instead of empty string
// //   });

// //   const [currentDate, setCurrentDate] = useState('');

// //   const getPageTitle = (pathname) => {
// //     if (pathname.includes('/dashboard')) return 'Dashboard';
// //     if (pathname.includes('/user-management')) return 'User Management';
// //     if (pathname.includes('/students')) return 'Student List';
// //     if (pathname.includes('/sponsor')) return 'Sponsor List';
// //     return 'Overview';
// //   }
// //   useEffect(() => {
// //     const date = new Date();
// //     const options = { weekday: 'long', day: 'numeric', month: 'short' };
// //     setCurrentDate(date.toLocaleDateString('en-GB', options));

// //     const loadData = async () => {
// //       const decoded = getDecodedToken();
// //       if (!decoded || !decoded.userId) {
// //         navigate('/login');
// //         return;
// //       }

// //       let profileData = {
// //         name: 'User',
// //         role: decoded.role || 'Admin',
// //         avatar: null
// //       };

// //       try {
// //         const response = await apiFetch(`/users/${decoded.userId}`);

// //         if (response.ok) {
// //           const data = await response.json();
// //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// //           profileData.name = fullName || 'User';
// //           profileData.role = data.role || decoded.role;
// //           profileData.avatar = data.photo_url || null; // Ensure avatar is null if not present
// //         } else {
// //            console.warn("Failed to fetch user details from API. Using fallback data.");
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch user details from API", error);
// //       }

// //       if (!profileData.avatar) {
// //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// //       }

// //       setUserProfile(profileData);
// //     };

// //     loadData();
// //   }, [navigate]);

// //   return (
// //     <header className="topbar">
// //       <div className="header-left">
// //         <span className="breadcrumb-main">Dashboard</span> 
// //         <span className="breadcrumb-separator">/</span> 
// //         <span className="breadcrumb-current">{getPageTitle(location.pathname)}</span>
// //       </div>

// //       <div className="header-right">
// //         <span className="date-display">{currentDate}</span>

// //         <div className="icon-group">
// //             <button className="icon-btn" title="Notifications">
// //                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
// //                 <span className="notification-dot"></span>
// //             </button>
// //             <button className="icon-btn" title="Settings" onClick={() => navigate('/settings')}>
// //                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
// //             </button>
// //         </div>

// //         <div className="profile-section" onClick={() => navigate('/settings')} title="View Profile">
// //           {/* --- FIX: Only render img if avatar src exists --- */}
// //           {userProfile.avatar && (
// //             <img 
// //               src={userProfile.avatar} 
// //               alt="Profile" 
// //               className="profile-img" 
// //             />
// //           )}
// //           <div className="profile-info">
// //             <span className="profile-name">{userProfile.name}</span>
// //             <span className="profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// //           </div>
// //         </div>
// //       </div>
// //     </header>
// //   );
// // };

// // export default Header;

// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './Header.css';
// import logo from '../../assets/logo.png'; // Assuming the logo is saved here

// const Header = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [currentDate, setCurrentDate] = useState('');

//   const getPageTitle = (pathname) => {
//     if (pathname.includes('/dashboard')) return 'Dashboard';
//     if (pathname.includes('/user-management')) return 'User Management';
//     if (pathname.includes('/students')) return 'Student List';
//     if (pathname.includes('/sponsor')) return 'Sponsor List';
//     return 'Overview';
//   }

//   useEffect(() => {
//     const date = new Date();
//     const options = { weekday: 'long', day: 'numeric', month: 'short' };
//     setCurrentDate(date.toLocaleDateString('en-GB', options));
//   }, []);

//   return (
//     <header className="topbar">
//       <div className="header-left">
//         <span className="breadcrumb-main">Dashboard</span> 
//         <span className="breadcrumb-separator">/</span> 
//         <span className="breadcrumb-current">{getPageTitle(location.pathname)}</span>
//       </div>

//       <div className="header-right">
//         <span className="date-display">{currentDate}</span>

//         <div className="icon-group">
//             <button className="icon-btn" title="Notifications">
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
//                 <span className="notification-dot"></span>
//             </button>
//             <button className="icon-btn" title="Settings" onClick={() => navigate('/settings')}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
//             </button>
//         </div>

//         <img src={logo} alt="Company Logo" className="header-logo" />
//       </div>
//     </header>
//   );
// };

// export default Header;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logo.png';
import NotificationDropdown from '../Notifications/NotificationDropdown';

const Header = ({ toggleMobileSidebar, isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [currentDate, setCurrentDate] = useState('');

  const getPageTitle = (pathname) => {
    if (pathname.includes('/dashboard')) return 'Dashboard';
    if (pathname.includes('/user-management')) return 'User Management';
    if (pathname.includes('/students')) return 'Student List';
    if (pathname.includes('/sponsor')) return 'Sponsor List';
    if (pathname.includes('/teachers')) return 'Teacher List';
    if (pathname.includes('/marks-entry')) return 'Marks Entry';
    if (pathname.includes('/attendance')) return 'Attendance';
    if (pathname.includes('/settings')) return 'Settings';
    if (pathname.includes('/report-cards')) return 'Report Cards';
    if (pathname.includes('/school-configuration')) return 'School Configuration';
    if (pathname.includes('/student/')) return 'Student Portal';
    return 'Overview';
  };

  useEffect(() => {
    const date = new Date();
    const options = { weekday: 'long', day: 'numeric', month: 'short' };
    setCurrentDate(date.toLocaleDateString('en-GB', options));
  }, []);

  return (
    <header className="topbar">
      <div className="header-left">
        {/* Hamburger menu button - visible on mobile */}
        {isMobile && (
          <button
            className="hamburger-btn"
            onClick={toggleMobileSidebar}
            aria-label="Toggle menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        )}

        {/* Breadcrumb navigation */}
        <span className="breadcrumb-main">Dashboard</span>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">{getPageTitle(location.pathname)}</span>
      </div>

      <div className="header-right">
        <span className="date-display">{currentDate}</span>

        <div className="icon-group">
          <NotificationDropdown />

          <button className="icon-btn" title="Settings" onClick={() => navigate('/settings')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </button>
        </div>

        <img src={logo} alt="Company Logo" className="header-logo" />
      </div>
    </header>
  );
};

export default Header;